import React from 'react';
import { message, Space, Table, Pagination, Tag, Modal, Button, Select } from 'antd';
import { Link } from 'react-router-dom';
import { httpClient } from "util/Api";
import { compareUIElementValue } from 'util/Compare';
import { config } from "util/config";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import CustomButton from 'components/UIBuilder/CustomComponent/CustomButton';
import { DragHandle, SortableItem, SortableBody, updateBeforeSortStart } from "components/UIBuilder/Global/SortableHelper";
import { setTableColumns } from "components/UIBuilder/Global/TableHelper";
import { getSectionFolderDataList } from "components/UIBuilder/Global/DataHelper";
import UploadDocument from './UploadDocument';
import CustomEmpty from "components/CustomEmpty";

export default class DocumentNoFolderTable extends React.Component {
  constructor(props) {
    super();
    this.state = {
      columns: [],
      data: [],
      sort: false,
      pagination: {
        current: 1,
        ...config.component.Pagination
      },
      loaded: false, // 加载是否完成
      selectedRowKeys: [],
      componentDataSource: [],
      uploadDocumentShow: false,
      changeTypeShow: false,
      changeFolderShow: false,
      shareControlShow: false,
      recycleBinShow: false,
      stampingShow: false,
      manageFolderShow: false,
      combinePdfShow: false,
    }

    this.uploadDocument = React.createRef();

    //表格选择行的配置
    this.rowSelection = props.viewConfig.groupList[0].rowSelectionType !== null ? {
      type: props.viewConfig.groupList[0].rowSelectionType,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeys});
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      ...this.state.rowSelection
    } : null;
  }

  // //只有数据源变化时才刷新table
  // shouldComponentUpdate(nextProps, nextState) {
  //   return nextState.data !== this.state.data;
  // }

  //获取table的表头和数据
  componentDidMount() {
    if (this.props.section.autoLoad) {
      this.getSectionDataByDefault();
    }
    this.setState({ columns: setTableColumns({ props: this.props, sort: this.state.sort, sectionComponent: this.props.parentComponent, pageComponent: this.props.pageComponent }) })
  }

  //默认获取数据的方法
  getSectionDataByDefault() {
    getSectionFolderDataList({ component: this, current: this.state.pagination.current, pageSize: this.state.pagination.pageSize });
  }

  render() {
    return (
      <>
        {
          this.state.loaded ?
            this.state.data.length > 0 ? //判断有没有数据
              <Table
                bordered
                size="small"
                rowSelection={this.rowSelection}
                columns={this.state.columns}
                dataSource={this.state.data}
                scroll={config.component.Table.scroll}
                pagination={this.props.viewConfig.groupList[0].pageable ?
                  {
                    ...this.state.pagination,
                    onChange: this.handlePaginationChange
                  }
                  : false}
                components={this.state.sort ? //判断是否带排序功能
                  {
                    body: {
                      wrapper: this.DraggableContainer,
                      row: this.DraggableBodyRow,
                    },
                  } : null}
                onRow={(record, index) => {
                  return {
                    onClick: event => { }, // 点击行
                    onDoubleClick: event => { }, // 双击行
                    onContextMenu: event => { }, //右击行
                    onMouseEnter: event => { }, // 鼠标移入行
                    onMouseLeave: event => { }, // 鼠标移出行
                  };
                }}
              />
              :
              <CustomEmpty /> : <img className='loading-icon' src="assets/images/icon/loading.svg" />
        }
        <UploadDocument ref={this.uploadDocument} {...this.props} component={this} />
      </>
    )
  }
}
